import React from "react";

import { Flex, FlexProps, Link, LinkProps } from "@catchoftheday/cg-components";
import { styled, themeGet } from "@catchoftheday/theme";

type CustomProps = {
  hasRightBorder?: boolean;
};
export type HeaderTileContainerProps = CustomProps & {
  flexProps?: FlexProps;
  linkProps?: { "data-tracking"?: string } & Omit<LinkProps, "ref">;
  children: React.ReactNode;
};

const FlexContainer = styled(Flex)<CustomProps>`
  ${(props) => props.hasRightBorder && `border-right: 1px solid white;`}
`;

const LinkContainer = styled(Link)`
  display: flex;
  height: 100%;
  &:hover,
  &:focus {
    color: ${themeGet("colors.secondaryDark")};
    background-color: white;
    text-decoration: underline;
  }
`;

export const HeaderTileContainer: React.FC<HeaderTileContainerProps> = ({
  children,
  hasRightBorder,
  flexProps,
  linkProps,
  ...props
}) => (
  <LinkContainer {...linkProps} {...props}>
    <FlexContainer
      hasRightBorder={hasRightBorder}
      height="100%"
      alignItems="center"
      {...flexProps}
    >
      {children}
    </FlexContainer>
  </LinkContainer>
);

HeaderTileContainer.defaultProps = {
  hasRightBorder: true,
};

export default HeaderTileContainer;
